import { render, staticRenderFns } from "./infoRate.vue?vue&type=template&id=66fbb381&scoped=true&"
import script from "./infoRate.vue?vue&type=script&lang=js&"
export * from "./infoRate.vue?vue&type=script&lang=js&"
import style0 from "./infoRate.vue?vue&type=style&index=0&id=66fbb381&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbb381",
  null
  
)

export default component.exports